var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMuebles(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.912,
    height: 93.786,
    viewBox: "0 0 96.912 93.786",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_052-relax",
    "data-name": "052-relax",
    transform: "translate(-8 -16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_281",
    "data-name": "Trazado 281",
    d: "M97.1,252.5v-4.689A7.823,7.823,0,0,0,89.281,240H62.708a7.805,7.805,0,0,0-6.253,3.133A7.805,7.805,0,0,0,50.2,240H23.631a7.823,7.823,0,0,0-7.815,7.815V252.5A7.823,7.823,0,0,0,8,260.32v28.136a1.563,1.563,0,0,0,1.563,1.563h93.786a1.563,1.563,0,0,0,1.563-1.563V260.32A7.823,7.823,0,0,0,97.1,252.5ZM23.631,286.893h-12.5V260.32a4.7,4.7,0,0,1,4.689-4.689h3.126a4.7,4.7,0,0,1,4.689,4.689ZM18.942,252.5v-4.689a4.7,4.7,0,0,1,4.689-4.689H50.2a4.7,4.7,0,0,1,4.689,4.689v18.761a7.778,7.778,0,0,0-4.689-1.567H31.446a7.778,7.778,0,0,0-4.689,1.567V260.32a7.823,7.823,0,0,0-7.815-7.815Zm35.951,20.32v4.689H26.757v-4.689a4.7,4.7,0,0,1,4.689-4.689H50.2a4.7,4.7,0,0,1,4.689,4.689Zm31.262,14.068h-59.4V280.64h59.4Zm0-9.379H58.019v-4.689a4.7,4.7,0,0,1,4.689-4.689H81.465a4.7,4.7,0,0,1,4.689,4.689Zm0-17.194v6.256a7.778,7.778,0,0,0-4.689-1.567H62.708a7.778,7.778,0,0,0-4.689,1.567V247.815a4.7,4.7,0,0,1,4.689-4.689H89.281a4.7,4.7,0,0,1,4.689,4.689V252.5A7.823,7.823,0,0,0,86.155,260.32Zm15.631,26.573h-12.5V260.32a4.7,4.7,0,0,1,4.689-4.689H97.1a4.7,4.7,0,0,1,4.689,4.689Z",
    transform: "translate(0 -180.233)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_282",
    "data-name": "Trazado 282",
    d: "M176.456,16H129.563A1.563,1.563,0,0,0,128,17.563V51.951a1.563,1.563,0,0,0,1.563,1.563h46.893a1.563,1.563,0,0,0,1.563-1.563V17.563A1.563,1.563,0,0,0,176.456,16Zm-1.563,34.388H131.126V19.126h43.767Z",
    transform: "translate(-96.554)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_283",
    "data-name": "Trazado 283",
    d: "M191.077,40H153.563A1.563,1.563,0,0,0,152,41.563V66.573a1.563,1.563,0,0,0,1.563,1.563h37.514a1.563,1.563,0,0,0,1.563-1.563V41.563A1.563,1.563,0,0,0,191.077,40ZM160.026,65.009l4.478-5.373,4.478,5.373Zm13.026,0L169.8,61.1l6.368-7.642,8.661,11.549Zm16.461,0h-.782L177.478,50a1.563,1.563,0,0,0-2.452-.063l-7.264,8.718-2.055-2.466a1.564,1.564,0,0,0-2.4,0l-7.347,8.816h-.83V43.126h34.388Z",
    transform: "translate(-115.864 -19.311)",
    fill: "#86888b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_284",
    "data-name": "Trazado 284",
    d: "M196.689,73.379A4.689,4.689,0,1,0,192,68.689,4.689,4.689,0,0,0,196.689,73.379Zm0-6.252a1.563,1.563,0,1,1-1.563,1.563A1.563,1.563,0,0,1,196.689,67.126Z",
    transform: "translate(-148.049 -38.621)",
    fill: "#003082"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuebles);
export default __webpack_public_path__ + "static/media/muebles.4bc5832aefc51e7133304ccab003e259.svg";
export { ForwardRef as ReactComponent };